<template>
  <el-dialog
    :title="title+ '——套餐'"
    :visible.sync="visible"
    width="800px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="套餐名称"
        width="100"
        prop="servicePackageName"
      ></el-table-column>
      <el-table-column
        label="检测标准"
        prop="testStandard"
      ></el-table-column>
      <el-table-column
        label="检测内容"
        prop="features"
      ></el-table-column>
      <el-table-column
        label="检测资质"
        prop="testQualification"
      ></el-table-column>
      <el-table-column
        label="抽样数量"
        prop="sampleQuantity"
      ></el-table-column>
      <el-table-column
        label="周期（天）"
        prop="cycleDays"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="{ row }">
          <el-button
            type="info"
            @click="updateitem(row)">
            编辑
          </el-button>
          <el-button
            type="danger"
            @click="deleteitem(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        关闭
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="addPackage">
        新增
      </el-button>
    </span>
    <edit-package-modal
      ref="package"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </el-dialog>
</template>

<script>
import EditPackageModal from './edit-package-modal.vue'

export default {
  name: 'PackageModal',
  components: { EditPackageModal },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      title: '',
      list: [],
      config: {
        serviceCategoryId: null
      }
    }
  },
  methods: {
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteservicepackage', {
          payload: {
            servicePackageId: row.servicePackageId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.config.serviceCategoryId = null
      this.list = []
    },
    updateitem(row) {
      this.$refs.package.update(row)
    },
    addPackage() {
      this.$refs.package.add(this.config.serviceCategoryId)
    },
    getlist(cb) {
      this.loading = true
      this.$store.dispatch('account/getservicepackages', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records.map(i => {
            return {
              ...i,
              cycleDays: i.cycleDays || undefined
            }
          })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    init(row) {
      this.config.serviceCategoryId = row.serviceCategoryId
      this.title = row.serviceCategoryName
      this.getlist(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
